/**
 * Открыть внешнюю цель (Фаза 6.4). На Android `intent://`/`max://` НЕ открываются
 * через `window.open`/новую вкладку (подтверждено на устройстве — грузится сайт),
 * поэтому app-схемы открываем ПРЯМОЙ навигацией `location.href`. http(s) (TG t.me,
 * MAX https на desktop/iOS) — в новую вкладку, чтобы не уводить PWA со страницы.
 * Для app-схемы на Android прямой переход НЕ выгружает текущую страницу (запуск
 * приложения), поэтому персистентный тост на экране остаётся виден по возвращении.
 */
export function openExternal(url: string): void {
  if (/^https?:/i.test(url)) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    window.location.href = url;
  }
}
